import { erpApi } from "../axios";
import { urlBackend } from "..";


/**
 * Hook para manejar bloqueo de registros de manera personalizada desde el frontend.
 * @param recordId ID del registro a bloquear
 */
export function useRecordDirectLock(
  recordId: string,
) {
  const { get, post, remove } = erpApi();

  const lockUrl = `${urlBackend}api/v1/${recordId}/lock/`;
  const renewUrl = `${urlBackend}api/v1/${recordId}/lock/renew/`;

  /**
   * Adquiere el lock del registro. Se puede enviar un objeto con los siguientes parámetros:
   * timeout: Tiempo en segundos para el lock (por defecto 300 segundos = 5 minutos). Si se envía un valor 
   * negativo, el lock permanecerá por tiempo indefinido hasta que sea eliminado.
   * 
   * @param bodyParams Parámetros opcionales para la solicitud de lock
   */
  const acquireLock = async (bodyParams: { timeout?: number } = {}) => {
    try {
      await post<any>(lockUrl, bodyParams, true);
    } catch (error) {
      console.error("No fue posible adquirir el lock", error);
      remove(lockUrl, true).catch(() => {});
    }
  };

  const renewLock = async (bodyParams:any = {}) => {
    try {
      await post<any>(renewUrl, bodyParams, true);
    } catch (error) {
      console.error("No fue posible renovar el lock", error);
      remove(lockUrl, true).catch(() => {});
    }
  };

  const releaseLock = async () => {
    try {
      await remove(`${lockUrl}?force=true`, true);
    } catch (error) {
      console.error("No fue posible liberar el lock", error);
    }
  };

  const getUserLocks = async () => {
    try {
      const data = await get<any>(lockUrl, true, true);
      return data;
    } catch (error) {
      console.error("No fue posible adquirir el lock", error);
      remove(lockUrl, true).catch(() => {});
      throw error;
    }
  };



  return {
    acquireLock,
    renewLock,
    releaseLock,
    getUserLocks
  }
}